package co.maytes.standupbot.dashboard.features.settings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.dashboard.stores.ToastKind
import co.maytes.standupbot.dashboard.stores.UiContainer
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.dashboard.stores.rememberUiStore
import co.maytes.standupbot.shared.dto.workspace.UpdateWorkspaceRequestDto
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

class WorkspacePatcher(
    private val store: SettingsStore,
    private val ui: UiContainer,
    private val scope: CoroutineScope,
    private val workspaceId: String?,
) {
    var saving by mutableStateOf(false)
        private set
    var error by mutableStateOf<String?>(null)
        private set

    fun save(body: UpdateWorkspaceRequestDto, successMessage: String) {
        val id = workspaceId ?: return
        if (saving) return
        saving = true
        error = null
        scope.launch {
            when (val result = store.patchWorkspace(id, body)) {
                is Result.Ok -> ui.showToast(successMessage, ToastKind.Success)
                is Result.Err -> {
                    error = result.error.displayMessage
                    ui.showToast("Save failed: ${result.error.displayMessage}", ToastKind.Error)
                }
            }
            saving = false
        }
    }
}

@Composable
fun rememberWorkspacePatcher(): WorkspacePatcher {
    val auth = rememberAuthStore()
    val store = rememberSettingsStore()
    val ui = rememberUiStore()
    val scope = rememberCoroutineScope()
    val workspaceId = auth.currentUser?.workspace?.id
    return remember(workspaceId) { WorkspacePatcher(store, ui, scope, workspaceId) }
}
